import { z } from "zod";
import { goodslineSchema } from "./Goodsline";
import { documentsSchema } from "./Document";
import { itemlineSchema } from "./Itemline";
import { addressSchema } from "./Address";


export const shipmentSchema = z.object({
    shipmentId: z.string().max(50).describe("primaryKey"),
    status: z.number().max(100),
    dispDate: z.string().refine(val =>
        (/^\d{4}-\d{2}-\d{2}$/g).test(val) || (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/g).test(val), {
        message: "Invalid date format. Must be yyyy-MM-dd or yyyy-MM-dd HH:mm",
      }),
    
    receiverPays: z.boolean().default(false),
    customerNumber: z.string().max(50).optional(),
    
    deliveryType: z.string().max(50),
    deliveryTypeName: z.string().max(50).optional().readonly(),
    carrier: z.string().max(50).optional(),
    orderNumber: z.string().max(50).optional(),
    // customerNumber: z.string().optional(),
    
    trackingNumber: z.string().readonly().nullish(),
    trackingLink: z.string().readonly().nullish(),
    combiterms: z.string().max(10).optional(),
    incotermsFreetext: z.string().optional(),

    goodsLines: z.array(goodslineSchema).optional(),
    itemLines: z.array(itemlineSchema).optional(),
    validationError: z.string().readonly().nullish(),
    noteInternal: z.string().optional(),
    checked: z.boolean().optional(),
    isInbound: z.boolean().readonly(),
    bookingType: z.enum(["WEBSERVICE", "EDI", "NONE"]).readonly(),
    isBooked: z.boolean().readonly(),
    documents: z.array(documentsSchema).optional(),
    msgToFW1: z.string().max(70).optional(),
    msgToFW2: z.string().max(70).optional(),
    msgToFW3: z.string().max(70).optional(),
    addresses: z.object({
        sender: addressSchema.optional().nullable(),
        receiver: addressSchema
    }),
    carrierSuiteId: z.string().optional(),
    
    currency: z.string().max(5).optional(),
    value: z.number().optional(),
    //NeededFields..
    arrivalDate: z.string().refine(val =>
        (/^\d{4}-\d{2}-\d{2}$/g).test(val) || (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/g).test(val), {
        message: "Invalid date format. Must be yyyy-MM-dd or yyyy-MM-dd HH:mm",
      }).optional(),
    arrivalTime: z.string().optional().readonly(),
    dispTime: z.string().optional().readonly(),
    category: z.string().optional(),
    insurance: z.object({
        value: z.number(),
        currency: z.string().max(5),
    }).optional(),
});

export type ShipmentType = z.infer<typeof shipmentSchema>;